import CheckBox from '@app/components/CheckBox'
import { IContextReminder } from '@app/models/ContextReminder'
import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import { Input } from 'reactstrap'
import {
  actionCreators,
  IContextReminderState,
} from '../modules/contextReminder'
import ContextReminderItem from './ContextReminderItem'

interface IComponentProps {
  contextId: string
}

export default class ContextReminderContainer extends React.PureComponent<
  IContextReminderState &
    IComponentProps &
    ICurrentUserState &
    typeof actionCreators,
  {}
> {
  public constructor(props: any) {
    super(props)

    bindFunctions(this)

    if (this.props.contextId) {
      this.props.loadReminders(this.props.contextId)
    }
  }

  public componentWillReceiveProps(nextProps: any) {
    if (nextProps.contextId !== this.props.contextId) {
      this.props.loadReminders(this.props.contextId)
    }
  }

  public render() {
    return (
      <div>
        <div className='d-flex flex-row mb-2'>
          <CheckBox
            value={this.props.showCompleted}
            onChange={(e) => {
              this.props.setShowCompleted(this.props.contextId, e)
            }}
          >
            Show Completed
          </CheckBox>
        </div>
        <Input
          placeholder='New reminder...'
          onChange={(e) => {
            this.props.setReminderText(e.target.value)
          }}
          onKeyDown={(e: any) => {
            if (e.keyCode === 13) {
              this.props.createNewReminder(
                this.props.contextId,
                e.target.value,
              )
            }
          }}
          value={this.props.reminderText}
        />

        <div className='mt-4'>{this._renderReminderItems()}</div>
      </div>
    )
  }

  private _renderReminderItems() {
    const reminders = this.props.reminders.map((r?: IContextReminder) => {
      if (r && r.text !== '') {
        return <ContextReminderItem key={r.id} {...this.props} reminder={r} />
      }

      return null
    })

    return <div>{reminders}</div>
  }
}
